import { render, staticRenderFns } from "./StudentSpareParts.vue?vue&type=template&id=a8a19224&scoped=true&"
import script from "./StudentSpareParts.vue?vue&type=script&lang=js&"
export * from "./StudentSpareParts.vue?vue&type=script&lang=js&"
import style0 from "./StudentSpareParts.vue?vue&type=style&index=0&id=a8a19224&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a19224",
  null
  
)

export default component.exports